import { IDKind } from '@startuptools/common/common';

export enum InputState {
  System,
  CompanyBoard,
  Swedish,
  Foreign,
  Fictitious,
}

export enum DetailState {
  Hidden,
  Required,
  Optional,
}

export interface DetailFieldsSettings {
  email?: DetailState;
  phone?: DetailState;
  address?: DetailState;
  countryCode?: DetailState;
}

export enum JuridicalKind {
  Person,
  Company,
}

export function isSwedish(identity: { identityNumberKind: unknown }): boolean {
  return (
    identity.identityNumberKind === IDKind.SwedishOrgNumber || identity.identityNumberKind === IDKind.SwedishPersonalID
  );
}
